import React from 'react';
import { Facebook, EnvelopeFill, CupHotFill } from 'react-bootstrap-icons';

export function EmailIcon() {
  return (<a href="mailto:sailing-handicap-calculator@windswept.org.uk?subject=Sailing Handicap Calculator Feedback">
    <EnvelopeFill/>
  </a>);
}

export function FacebookIcon() {
  return (<a href="https://www.facebook.com/people/Sailing-Handicap-Calculator/100086783102535/">
    <Facebook/>
  </a>);
}

export function BuyMeACoffeeIcon() {
  return (<a href="https://www.buymeacoffee.com/SteveAtk">
    <CupHotFill/>
  </a>);
}
